import { render, staticRenderFns } from "../views/query_executor.html?vue&type=template&id=aff112d6&scoped=true&"
import script from "../scripts/query_executor.ts?vue&type=script&lang=ts&"
export * from "../scripts/query_executor.ts?vue&type=script&lang=ts&"
import style0 from "./query_executor.vue?vue&type=style&index=0&id=aff112d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff112d6",
  null
  
)

/* vuetify-loader */
import installComponents from "!/home/ujjwal/projects/opensource/idbstudio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('aff112d6', component.options)
    } else {
      api.reload('aff112d6', component.options)
    }
    module.hot.accept("../views/query_executor.html?vue&type=template&id=aff112d6&scoped=true&", function () {
      api.rerender('aff112d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/query_executor.vue"
export default component.exports